export const menuData = [
  { label: "Projects", to: "projects", options: { offset: -70, duration: 500 } },
  { label: "About", to: "about", options: { offset: -70, duration: 500 } },
  { label: "Testimonials", to: "testimonials", options: { offset: -70, duration: 500 } },
  { label: "Contact", to: "contact", options: { offset: -70, duration: 500 } },
  { label: "Disclaimer", to: "disclaimer", options: { offset: -70, duration: 500 }, touch: 1 },
];
